import React from 'react';
import SEO from '../components/common/SEO';
import TemplatesSection from '../components/websites/TemplatesSection';

const Websites = () => {
  return (
    <>
      <SEO
        title="Website Templates & Designs"
        description="Browse our collection of responsive, premium website templates and client website designs ready for customization."
        keywords="website templates, responsive website themes, showit templates, luxury website design"
      />
      <TemplatesSection />
    </>
  );
};

export default Websites;
